module.exports = __webpack_public_path__ + "img/gated_content.e410fcc4.jpg";